/**
 * Single definition of onboarding-pricing display math (spec DC-2/C2).
 * The server computes the actual charge; this module only renders it.
 */
export interface ActiveDiscount {
  code: string;
  type: 'PERCENTAGE_DISCOUNT' | 'FIXED_DISCOUNT_AMOUNT';
  rate?: number;
  discountAmount?: number;
  billingPackageCode?: string;
  description?: string;
}

const toCents = (n: number): number => Math.round(n * 100) / 100;

export function discountAppliesTo(packageCode: string, discount: ActiveDiscount | null): boolean {
  if (!discount) { return false; }
  return !discount.billingPackageCode || discount.billingPackageCode === packageCode;
}

export function calculateDisplayPrice(price: number, discount: ActiveDiscount | null, packageCode: string): number {
  if (price <= 0 || !discountAppliesTo(packageCode, discount)) { return toCents(price); }
  if (discount!.type === 'PERCENTAGE_DISCOUNT' && discount!.rate) {
    return toCents(price * (1 - discount!.rate / 100));
  }
  if (discount!.type === 'FIXED_DISCOUNT_AMOUNT' && discount!.discountAmount) {
    return toCents(Math.max(0, price - discount!.discountAmount));
  }
  return toCents(price);
}

export function saveAmount(price: number, discount: ActiveDiscount | null, packageCode: string): number {
  return toCents(price - calculateDisplayPrice(price, discount, packageCode));
}

export function discountLabel(discount: ActiveDiscount | null): string {
  if (!discount) { return ''; }
  if (discount.type === 'FIXED_DISCOUNT_AMOUNT') { return discount.discountAmount ? `$${discount.discountAmount} off` : ''; }
  return discount.rate ? `${discount.rate}% off` : '';
}
